import React, { useState } from "react";
import { useGrade } from "../../../context/GradeContext";
import config from '../../../config';


const DataManagement = () => {

  const { grade } = useGrade();
  console.log(grade);

  const [activeTab, setActiveTab] = useState("students");
  const [scope, setScope] = useState("all"); // all | class
  const [selectedClass, setSelectedClass] = useState("");
  const [exportType, setExportType] = useState("minimal"); // minimal | full
  const [format, setFormat] = useState("excel"); // excel | csv

  const handleExport = () => {
    let baseUrl = `${config.apiBaseUrl}/`;

    let file = "";

    if (activeTab === "students") {
      if (exportType === "minimal") {
        file = format === "excel"
          ? "students/export-minimal-excel.php"
          : "students/export-minimal-csv.php";
      } else {
        file = format === "excel"
          ? "students/export-excel.php"
          : "students/export-csv.php";
      }
    }

    if (activeTab === "teachers") {
      file = "teachers/export.php"; // placeholder
    }

    if (activeTab === "staff") {
      file = "staff/export.php"; // placeholder
    }

    let url = baseUrl + file;

    if (scope === "class" && selectedClass) {
      url += `?class_id=${selectedClass}`;
    }

    window.open(url, "_blank");
  };

  return (
    <div className="row">
      <div className="col-xl-12">
        <div className="card">

          <div className="card-header">
            <h5 className="mb-0">Data Management</h5>
          </div>

          <div className="card-body">

            {/* Tabs */}
            <ul className="nav nav-tabs mb-4">
              <li className="nav-item">
                <button
                  className={`nav-link ${activeTab === "students" ? "active" : ""}`}
                  onClick={() => setActiveTab("students")}
                >
                  Students
                </button>
              </li>

              <li className="nav-item">
                <button
                  className={`nav-link ${activeTab === "teachers" ? "active" : ""}`}
                  onClick={() => setActiveTab("teachers")}
                >
                  Teachers
                </button>
              </li>

              <li className="nav-item">
                <button
                  className={`nav-link ${activeTab === "staff" ? "active" : ""}`}
                  onClick={() => setActiveTab("staff")}
                >
                  Staff
                </button>
              </li>
            </ul>

            {/* STUDENTS TAB */}
            {activeTab === "students" && (
              <div>

                {/* Export Scope */}
                <div className="mb-3">
                  <label className="form-label fw-bold">Export Scope</label>
                  <div>
                    <div className="form-check form-check-inline">
                      <input
                        type="radio"
                        className="form-check-input"
                        checked={scope === "all"}
                        onChange={() => setScope("all")}
                      />
                      <label className="form-check-label">All Students</label>
                    </div>

                    <div className="form-check form-check-inline">
                      <input
                        type="radio"
                        className="form-check-input"
                        checked={scope === "class"}
                        onChange={() => setScope("class")}
                      />
                      <label className="form-check-label">Selected Class</label>
                    </div>
                  </div>
                </div>

                {/* Show Class Dropdown If Selected */}
                {scope === "class" && (
                  <div className="mb-3">
                    <label className="form-label">Select Class</label>
                    <select
                        className="form-select"
                        value={selectedClass}
                        onChange={(e) => setSelectedClass(e.target.value)}
                        >
                        <option value="">-- Select Class --</option>

                        {grade && grade.length > 0 ? (
                            grade.map((g) => (
                            <option key={g.value} value={g.value}>
                                {g.label}
                            </option>
                            ))
                        ) : (
                            <option disabled>No Classes Found</option>
                        )}
                    </select>


                  </div>
                )}

                {/* Export Type */}
                <div className="mb-3">
                  <label className="form-label fw-bold">Export Type</label>
                  <div>
                    <div className="form-check form-check-inline">
                      <input
                        type="radio"
                        className="form-check-input"
                        checked={exportType === "minimal"}
                        onChange={() => setExportType("minimal")}
                      />
                      <label className="form-check-label">Minimal</label>
                    </div>

                    <div className="form-check form-check-inline">
                      <input
                        type="radio"
                        className="form-check-input"
                        checked={exportType === "full"}
                        onChange={() => setExportType("full")}
                      />
                      <label className="form-check-label">Full</label>
                    </div>
                  </div>
                </div>

                {/* File Format */}
                <div className="mb-4">
                  <label className="form-label fw-bold">File Format</label>
                  <div>
                    <div className="form-check form-check-inline">
                      <input
                        type="radio"
                        className="form-check-input"
                        checked={format === "excel"}
                        onChange={() => setFormat("excel")}
                      />
                      <label className="form-check-label">Excel (.xlsx)</label>
                    </div>

                    <div className="form-check form-check-inline">
                      <input
                        type="radio"
                        className="form-check-input"
                        checked={format === "csv"}
                        onChange={() => setFormat("csv")}
                      />
                      <label className="form-check-label">CSV (.csv)</label>
                    </div>
                  </div>
                </div>

                <button className="btn btn-success" onClick={handleExport}>
                  Export Now
                </button>

              </div>
            )}

            {/* TEACHERS TAB */}
            {activeTab === "teachers" && (
              <div className="text-muted">
                Teacher export configuration coming next.
              </div>
            )}

            {/* STAFF TAB */}
            {activeTab === "staff" && (
              <div className="text-muted"> 
                Staff export configuration coming next.
              </div>
            )}

          </div>
        </div>
      </div>
    </div>
  );
};

export default DataManagement;
